import React from "react";
import { Link } from "react-router-dom";
import { BRAND_ASSETS } from "@/lib/brand";

export default function Logo({ variant = "dark", size = 40, className = "", asLink = true }) {
  const inner = (
    <img
      src={BRAND_ASSETS.logo}
      alt="SunPress Solar"
      style={{
        height: size,
        width: "auto",
        objectFit: "contain",
        filter: variant === "light" ? "brightness(0) invert(1)" : "none",
      }}
    />
  );
  if (!asLink) return <span className={className} data-testid="brand-logo">{inner}</span>;
  return (
    <Link to="/" data-testid="brand-logo" className={`inline-flex items-center ${className}`}>
      {inner}
    </Link>
  );
}
